module.exports = __webpack_public_path__ + "static/img/partner-dapp.1394ebd2.png";